// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1GGjX","vLegacy":"SelectSecondary_vLegacy__26dp8","error":"SelectSecondary_error__367Sf","disabled":"SelectSecondary_disabled__2WWL5"};